import axios from "axios";
import { KurbanURL } from "../../../config/UrlEndPoint";

export const URL = `${KurbanURL}partner_quota`;

// Get PartnerQuota All For use Combobox data
export function getPartnerQuotaAll() {
  return axios.get(URL);
}

//Get By ID
export function getPartnerQuotaById(parnerQuotaId) {
  return axios.get(`${URL}/${parnerQuotaId}`);
}

// items => filtered/sorted result for table data
export function findPartnerQuota(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

export function findPartnerQuotaQroup(queryParams) {
  return axios.post(`${URL}/find/quota`, queryParams);
}

// POST => POST: Create the parnerQuota on the server
export function createPartnerQuota(parnerQuota) {
  return axios.post(URL, parnerQuota);
}

// // UPDATE => PUT: update the parnerQuota on the server
// export function updatePartnerQuota(parnerQuota) {
//   return axios.put(`${URL}/${parnerQuota.uuid}`, parnerQuota);
// }

// // UPDATE => Delete: Delete the parnerQuota on the server
// export function deletePartnerQuota(uuid) {
//   return axios.delete(`${URL}/${uuid}`);
// }
